import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { setCookie } from "../../services/cookieService";
import { useForm } from "react-hook-form";
import "./UserDetailsForm.css";
import { createUserWithScore } from "../../services/firestoreService";
import { useEffect, useState } from "react";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

export default function UserDetailsForm({ score }) {
  const navigate = useNavigate();
  const [url, setUrl] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    data["score"] = score;
    const user = await createUserWithScore(data);
    const formSubmited = new CustomEvent("formFilled");
    window.dispatchEvent(formSubmited);
    setCookie("keff", user.id, 10);
    navigate("/thank-you");
  };

  useEffect(() => {
    const storage = getStorage();

    getDownloadURL(ref(storage, "keff-terms.pdf"))
      .then((termsUrl) => {
        setUrl(termsUrl.substring(0, termsUrl.indexOf("&")));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [url]);

  return (
    <>
      <form className="user-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-section">
          <label className="form-lable">שם:</label>
          <div className="name-section">
            <div className="form-section">
              <TextField
                size="small"
                type="text"
                placeholder="שם משפחה"
                {...register("lastName", {
                  required: "חובה למלא שדה זה",
                  minLength: {
                    value: 2,
                    message: "שם קצר מידי",
                  },
                  maxLength: {
                    value: 12,
                    message: "שם ארוך מידי",
                  },
                })}
              />
              {errors.lastName && (
                <p className="error">{errors.lastName.message}*</p>
              )}
            </div>
            <div className="spacer"></div>
            <div className="form-section">
              <TextField
                size="small"
                type="text"
                variant="outlined"
                placeholder="שם פרטי"
                {...register("firstName", {
                  required: "חובה למלא שדה זה",
                  minLength: {
                    value: 2,
                    message: "שם קצר מידי",
                  },
                  maxLength: {
                    value: 12,
                    message: "שם ארוך מידי",
                  },
                })}
              />
              {errors.firstName && (
                <p className="error">{errors.firstName.message}*</p>
              )}
            </div>
          </div>
        </div>
        <div className="form-section">
          <label className="form-lable">אימייל:</label>

          <TextField
            size="small"
            type="text"
            fullWidth
            placeholder="כתובת אימייל"
            {...register("email", {
              required: "חובה למלא שדה זה",
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: "כתובת אימייל לא תקנית",
              },
            })}
          />
          {errors.email && <p className="error">{errors.email.message}*</p>}
        </div>
        <div className="form-section">
          <label className="form-lable">פלאפון:</label>

          <TextField
            size="small"
            type="tel"
            fullWidth
            placeholder="מספר פלאפון"
            {...register("phone", {
              required: "חובה למלא שדה זה",
              pattern: {
                value:
                  /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
                message: "אנא הזינו מספר פלאפון תקין",
              },
              minLength: {
                value: 10,
                message: "מספר פלאפון קצר מידי",
              },
              maxLength: {
                value: 12,
                message: "מספר פלאפון ארוך מידי",
              },
            })}
          />
          {errors.phone && <p className="error">{errors.phone.message}*</p>}
        </div>
        <div className="form-section">
          <div className="check-container">
            <span className="checkbox-text">אני מאשר לקבל חומר פרסומי</span>

            <input
              className="checked-input"
              {...register("promotions")}
              type="checkbox"
              value={true}
            />
          </div>

          <div className="form-section">
            <div className="check-container">
              <a
                id="terms"
                className="checkbox-text"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                התקנון
              </a>
              <span className="checkbox-text">קראתי ומאשר את</span>
              <input
                className="checked-input"
                {...register("termsOfService", {
                  required: "חובה לאשר שדה זה",
                })}
                type="checkbox"
                value={true}
              />
            </div>
            {errors.termsOfService && (
              <p className="error">{errors.termsOfService.message}*</p>
            )}
          </div>
        </div>
        <div className="submit-btn-container">
          <Button
            variant="text"
            type="submit"
            onClick={() => handleSubmit(onSubmit)}
          >
            <img
              className="submit-btn-img"
              src={process.env.PUBLIC_URL + "Assets/fun_btn.png"}
              alt="submit-btn-img"
            ></img>
          </Button>
        </div>
      </form>
    </>
  );
}
